module.exports = __webpack_public_path__ + "img/comment-quote.ca6acf8d.svg";